<div class="po-wrapper" *ngIf="!isLoginRoute; else loginTpl">
  <po-toolbar
    p-title="GNF - Gestão de Notas Fiscais"
    [p-profile]="profile"
    [p-profile-actions]="profileActions">
  </po-toolbar>

  <po-menu
    [p-menus]="menus"
    [p-automatic-toggle]="true"
    [p-collapsed]="true"
    [p-logo]="(menuLogo$ | async) ?? 'assets/brand/logo-ascensus-positiva.png'">
  </po-menu>

  <router-outlet></router-outlet>
</div>

<ng-template #loginTpl>
  <router-outlet></router-outlet>
</ng-template>
